import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  customerSelect,
} from '../../redux/actions'

import Customer from '../../components/customer'
import NoData from '../../components/nodata'

class CustomerPage extends Component {

  componentWillMount() {
    this.props.start(this.props.match.params.cid)
  }

  render() {

    const {
      translate,
      selectedCustomer
    } = this.props

    if (selectedCustomer) {
      return (
        <Customer selectedCustomer={selectedCustomer} translate={translate} />
      )
    } else {
      return <NoData translate={translate} />
    }

  }

}

const mapStateToProps = (state) => ({
  selectedCustomer: state.customerReducer.customer,
  ...state,
})

const mapDispatchToProps = (dispatch, props) => ({
  start: (cid) => {
    dispatch(customerSelect(cid))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomerPage)
